import styled from '@emotion/styled'
import { Tr } from '@chakra-ui/react'

export const TableRow = styled(Tr)`
  td {
    height: 2.5rem;
  }

  .link {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:hover {
    opacity: 70%;
    cursor: pointer;
  }
`
